enum Colors {
  Text = "#252525",
  CardText = "#252525",
  Background = "#FFFFFF",
  CardBackground = "#F0F0F0",
  Frog = "#82CD47",
  Mail = "#32AAF8",
  Mastodon = "#563ACC",
  GitHub = "#171515",
  Cyan = "#00FFFF",
  Magenta = "#FF00FF",
  Yellow = "#FFFF00"
}

export default Colors;
